module.exports = __webpack_public_path__ + "media/images/cards/cc-paypal-607f2030fc5cb5aeb89342a16652a08e.svg";